$(document).ready(function() {

	$("#send-email").on("click tap", function() {

		var lang = window.location.pathname.split("/")[1].toLowerCase();

		var name = $("#name").val();
		if (name == "") {
			$("#name").addClass("error");
			return;
		}

		var surname = $("#surname").val();
		if (surname == "") {
			$("#surname").addClass("error");
			return;
		}

		var email = $("#email").val();
		if (!validateEmail(email)) {
			$("#email").addClass("error");
			return;
		}

		var city = $("#city").val();
		if (city == "") {
			$("#city").addClass("error");
			return;
		}

		var cap = $("#cap").val();

		var nation = $("#nation").val();
		if (nation == "") {
			$("#nation").addClass("error");
			return;
		}

		var company = $("#company").val();

		var website = $("#website").val();

		var obj = $(".box-product-navigator .active").data("type");

		if (obj == "") {
			$(".product-navigator").addClass("error");
			return;
		} else {
			switch (obj) {
				case "job":
					email_to = "info";
					obj = "Candidatura da sito da sito";
					break;
				case "support":
					email_to = "info";
					obj = "Richiesta supporto tecnico da sito";
					break;
				case "prod":
					email_to = "info";
					obj =
						"Richiesta informazioni prodotto " +
						$(".box-product-navigator .active").data("prod") +
						" da sito";
					break;
				case "general":
					email_to = "info";
					obj = "Richiesta informazioni generali da sito";
					break;
				case "proposal":
					email_to = "info";
					obj = "Proposta di collaborazione";
					break;
				default:
			}
		}

		var text = $("#form-contact-text").val();

		if (text == "") {
			$("#form-contact-text").addClass("error");
			return;
		}

		if (!$(".privacy .check-privacy").hasClass("active")) {
			$(".alert-error-privacy")
				.fadeIn()
				.css("display", "flex");
			return console.log("not privacy");
		}
		$(".alert-error-privacy").fadeOut();

		if ($(".privacy .check-newsletter").hasClass("active")) {
			// subscribeToMail(email);
		}

		grecaptcha.execute('6LdmYdUUAAAAABRYbbWo1MaE-wSfGzijyc-Q9QGo', {action: 'submit_contact_form'}).then(function(token) {

			var dataEmail = {
				name: name,
				surname: surname,
				nation: nation,
				company: company,
				city: city,
				cap: cap,
				email: email,
				website: website,
				email_to: email_to,
				obj: obj,
				text: text,
				token: token,
			};

			$.post("/send-mail", dataEmail, function(success) {

				if(success) {

					dataLayer.push({
						event: "form-message-sent",
						event_category: "contact-form",
						event_label: $("#email").val() + "-" + $('html').prop("lang"),
					});

				} else {

					dataLayer.push({
						event: "form-message-blocked",
						event_category: "contact-form",
						event_label: $("#email").val() + "-" + $('html').prop("lang"),
					});

				}

				// reset form
				$("#name").val("");
				$("#surname").val("");
				$("#nation").val("");
				$("#company").val("");
				$("#email").val("");
				$("#website").val("");
				$("#city").val("");
				$("#cap").val("");

				$("#form-contact-text").val("");
				$('.check-privacy').removeClass('active');
				// $('.check-newsletter').removeClass('active');
				$(".success")
				.fadeIn()
				.delay(15000)
				.fadeOut();

			});

		});

	});

	$("#section-contact input, #form-contact-text").on("focus", function() {
		$(this).removeClass("error");
	});
});

function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function subscribeToMail(email) {
	var lang = window.location.pathname.split("/")[1].toLowerCase();
	$.post(
		"/mail-list/subscribe",
		{
			email: email,
			lang: lang
		},
		function(data) {}
	);
}



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_contact.js
// module id = 7
// module chunks = 0